// extracted by mini-css-extract-plugin
export default {"Container":"WarningModal_Container__7zZ23","Secondary":"WarningModal_Secondary__FBvbP","Primary":"WarningModal_Primary__Z-3xO"};